import http from '../../../http/http';
import moment from 'moment';

const state = {
    open: false,
    menuItems: '',
    menuImg: '',
    leaImg: { img: 'lea.png' },
    openSettings: false,
    openLager: false,
    openPrimaer: false,
    openSekundaer: false,
    openSRM: false,
    openSFS: false,
    openEM: false,
    openKuechen: false,
    openAdmin: false

};

const getters = {
    open: (state) => state.open,
    menuItems: (state) => state.menuItems,
    menuImg: (state) => state.menuImg,
    leaImg: (state) => state.leaImg,
    openSettings: (state) => state.openSettings,
    openLager: (state) => state.openLager,
    openPrimaer: (state) => state.openPrimaer,
    openSekundaer: (state) => state.openSekundaer,
    openSRM: (state) => state.openSRM,
    openSFS: (state) => state.openSFS,
    openEM: (state) => state.openEM,
    openKuechen: (state) => state.openKuechen,
    openAdmin: (state) => state.openAdmin
};

const mutations = {
    open: (state, payload) => {
        state.open = payload;
    },
    menuItems: (state, payload) => {
        state.menuItems = payload;
    },
    menuImg: (state, payload) => {
        state.menuImg = payload;
    },
    leaImg: (state, payload) => {
        state.leaImg = payload;
    },
    openSettings: (state, payload) => {
        state.openSettings = payload;
    },
    openLager: (state, payload) => {
        state.openLager = payload;
    },
    openPrimaer: (state, payload) => {
        state.openPrimaer = payload;
    },
    openSekundaer: (state, payload) => {
        state.openSekundaer = payload;
    },
    openSRM: (state, payload) => {
        state.openSRM = payload;
    },
    openSFS: (state, payload) => {
        state.openSFS = payload;
    },
    openEM: (state, payload) => {
        state.openEM = payload;
    },
    openKuechen: (state, payload) => {
        state.openKuechen = payload;
    },
    openAdmin: (state, payload) => {
        state.openAdmin = payload;
    }
};

const actions = {
    open: ({ commit }, payload) => {
        commit('open', payload);
    },
    leaImg: ({ commit }) => {
        let data = {
            day: moment().format('DD.MM'),
            year: moment().format('DD.MM.YYYY')
            // time:moment().format('HH:mm')
        }

        http.post('/leaDates', data)
            .then((response) => {
                commit('leaImg', response.data);
            });
    },
    menuImg: ({ commit, state }, payload) => {
        if (payload === 'home') {
            commit('menuImg', 'lea.png');
        } else if (payload === 'users') {
            commit('menuImg', 'users.png');
        } else if (payload === 'settings') {
            commit('menuImg', 'settings.png');
        } else if (payload === 'kontakt') {
            commit('menuImg', 'msg.png');
        } else if (payload === 'fotodatenbank') {
            commit('menuImg', 'fdb2.png');
        } else if (payload === 'lager') {
            commit('menuImg', 'dolly.png');
        } else {
            commit('menuImg', state.leaImg.img);
        }
    },
    menuItems: ({ commit, getters, rootState }) => {
        var data = rootState.user.userData.autlev;

        var menuItems = [];

        // add the allowed menus into the menu store
        if (data.indexOf('0') > -1) {
            menuItems.push('users');
        }
        if (data.indexOf('1') > -1) {
            menuItems.push('kontakt');
            menuItems.push('settings');
        }
        if (data.indexOf('2') > -1) {
            menuItems.push('fotodatenbank');
        }
        if (data.indexOf('6') > -1 || data.indexOf('7') > -1) {
            menuItems.push('lager');
        }
        commit('menuItems', menuItems.sort());
    },
    openUrl: ({ state }) => {
        window.open(state.leaImg.url, '_blank');
    },
    openSettings: ({ commit, state }) => {
        if (state.openSettings) {
            commit('openSettings', false);
        } else {
            commit('openSettings', true);
        }
    },
    openLager: ({ commit, state }) => {
        if (state.openLager) {
            commit('openLager', false);
        } else {
            commit('openLager', true);
        }
    },
    openPrimaer: ({ commit, state }) => {
        if (state.openPrimaer) {
            commit('openPrimaer', false);
        } else {
            commit('openPrimaer', true);
        }
    },
    openSekundaer: ({ commit, state }) => {
        if (state.openSekundaer) {
            commit('openSekundaer', false);
        } else {
            commit('openSekundaer', true);
        }
    },
    openSRM: ({ commit, state }) => {
        if (state.openSRM) {
            commit('openSRM', false);
        } else {
            commit('openSRM', true);
        }
    },
    openSFS: ({ commit, state }) => {
        if (state.openSFS) {
            commit('openSFS', false);
        } else {
            commit('openSFS', true);
        }
    },
    openEM: ({ commit, state }) => {
        if (state.openEM) {
            commit('openEM', false);
        } else {
            commit('openEM', true);
        }
    },
    openKuechen: ({ commit, state }) => {
        if (state.openKuechen) {
            commit('openKuechen', false);
        } else {
            commit('openKuechen', true);
        }
    },
    openAdmin: ({ commit, state }) => {
        if (state.openAdmin) {
            commit('openAdmin', false);
        } else {
            commit('openAdmin', true);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
